import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  genericProductName: {
    id: 'productCardGrid.genericProductName',
    defaultMessage: 'All Courses',
    description: 'Fallback label for a product card with no product_name',
  },
  productImageAlt: {
    id: 'productCardGrid.productImageAlt',
    defaultMessage: '{title} image',
    description: 'Alt text for a product card image',
  },
  expired: {
    id: 'productCardGrid.expired',
    defaultMessage: 'Expired',
    description: 'Badge shown on an expired product card with no expiry date',
  },
  expiredOn: {
    id: 'productCardGrid.expiredOn',
    defaultMessage: 'Expired {expiryDate}',
    description: 'Badge shown on an expired product card with an expiry date',
  },
  expiresOn: {
    id: 'productCardGrid.expiresOn',
    defaultMessage: 'Expires {expiryDate}',
    description: 'Badge shown on a product card with an expiry date',
  },
  expandProduct: {
    id: 'productCardGrid.expandProduct',
    defaultMessage: 'Show courses for {title}',
    description: 'Accessible label for expanding a collapsed product accordion item',
  },
  collapseProduct: {
    id: 'productCardGrid.collapseProduct',
    defaultMessage: 'Hide courses for {title}',
    description: 'Accessible label for collapsing an expanded product accordion item',
  },
});

export default messages;
